"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTracker = void 0;

var _useGetTrackerParams2 = require("./useGetTrackerParams");

var _tracker = require("../../../utils/tracker");

var _excluded = ["isTrackingEnabled", "widgetName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useTracker = function useTracker(widgetNameParam, whitelabelNameParam) {
  var _useGetTrackerParams = (0, _useGetTrackerParams2.useGetTrackerParams)(widgetNameParam, whitelabelNameParam),
      isTrackingEnabled = _useGetTrackerParams.isTrackingEnabled,
      widgetName = _useGetTrackerParams.widgetName,
      trackerParams = _objectWithoutProperties(_useGetTrackerParams, _excluded);

  if (!isTrackingEnabled || !widgetName) {
    return;
  }

  (0, _tracker.initTracker)();

  var trackShow = function trackShow(customShowParams) {
    (0, _tracker.trackWidgetShow)(_objectSpread(_objectSpread({}, trackerParams), {}, {
      widgetName: widgetName,
      customShowParams: customShowParams
    }));
  };

  var trackSearchParamsChange = function trackSearchParamsChange(changedParams, newSearchParams) {
    var newConvertedParams = (0, _tracker.convertCigaretteParamsForTracking)(newSearchParams);

    var searchParams = _objectSpread(_objectSpread({}, trackerParams.searchParams), newConvertedParams);

    (0, _tracker.trackWidgetSearchParamsChange)(_objectSpread(_objectSpread({}, trackerParams), {}, {
      widgetName: widgetName,
      changedParams: changedParams,
      searchParams: searchParams
    }));
  };

  var trackError = function trackError(errorType) {
    (0, _tracker.trackWidgetError)(_objectSpread(_objectSpread({}, trackerParams), {}, {
      widgetName: widgetName,
      errorType: errorType
    }));
  };

  return {
    trackShow: trackShow,
    trackSearchParamsChange: trackSearchParamsChange,
    trackError: trackError
  };
};

exports.useTracker = useTracker;